import React, { Suspense, useEffect, useState } from "react";
import { api } from "api/Api";
import { CLINICIAN_REMOVE_APPLICATION, DELETE_TIMESHEET, GET_CLINICIAN_JOB_LIST } from "constants/ApiUrls";
import { APP_LIMIT, DEFAULT_TIMEZONE, RESPONSE_OK } from "constants/AppConstants";
import useAdminPermissions from "hooks/useAdminPermissions";
import { isEmpty } from "radash";
import DataTable from "react-data-table-component";
import Select from "react-dropdown-select";
import { Link } from "react-router-dom";
import { Fragment } from "react/cjs/react.production.min";
import { Input, Modal, ModalBody, ModalHeader, Spinner, UncontrolledPopover, UncontrolledTooltip } from "reactstrap";
import { ReactComponent as SortIcon } from "../../assets/images/icons/arrows-up.svg";
import { ReactComponent as TableMsgIcon } from "../../assets/images/icons/chat.svg";
import { CrossIcon, Options } from "../../assets/svg";
import "../../component/userListing/userListing.scss";
import { initShiftStatus, shiftStatus } from "../../views/authentication/signUpClinician/HourlyConstant";
import Loader from "component/Loader";
const AddressLabel = React.lazy(() => import("component/common/AddressLabel"));
const DeleteAJobModal = React.lazy(() => import("component/modals/DeleteAJobModal"));
const EnterTimeSheetModal = React.lazy(() => import("component/modals/timesheets/EnterTimeSheetModal"));
const CustomPagination = React.lazy(() => import("../../component/common/customPagination"));
const ReceiptClinicianModal = React.lazy(() => import("component/jobPosting/Modals/ReceiptClinician"));
const DatesLabel = React.lazy(() => import("component/common/DatesLabel"));


function MyConfirmShifts({ user, values, currentActiveTab }) {
  const initFilters = {
    skip: 0,
    limit: APP_LIMIT,
    forFacility: 0,
    shiftStatus: initShiftStatus,
    paymentStatus: "",
  };

  const [uploadModal, setUploadModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [filters, setFilters] = useState({ ...initFilters });
  const [sortFilters, setSortFilters] = useState({});
  const [selectedRow, setSelectedRow] = useState({});
  const [selected, setSelected] = useState(null);
  const [trigger, setTrigger] = useState(false);
  const [receiptModal, setReceiptModal] = useState(false);
  const [modal, setModal] = useState(false);
  const [deleteApplication, setDeleteApplication] = useState({});
  const [enterSheetModal, setEnterSheetModal] = useState(false);
  const [deleteSheetModal, setDeleteSheetModal] = useState(false);
  const [timeSheetId, setTimeSheetId] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  /**
   * The function toggleDropdown toggles the value of isDropdownOpen.
   */
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const { isAdmin, isSubadmin, isReadOnlyAdmin } = useAdminPermissions();
  const isAdminContext = isAdmin || isSubadmin || isReadOnlyAdmin;

  useEffect(() => {
    getData();
  }, [filters, trigger, currentActiveTab]);

  // Handle sorting on sort filters changes
  useEffect(() => {
    handleSorting();
  }, [sortFilters]);

  // Sort on client side, For faster exp
  const handleSorting = () => {
    if (sortFilters?.sortBy && data && data?.length) {
      setData((data) => {
        return data?.sort((a, b) => {
          if (sortFilters?.sortBy === "jobId") {
            if (sortFilters?.direction === "zToA") {
              return Number(b?.serialNumber) - Number(a?.serialNumber);
            } else {
              return Number(a?.serialNumber) - Number(b?.serialNumber);
            }
          } else if (sortFilters?.sortBy === "officeName") {
            if (sortFilters?.direction === "zToA") {
              return b?.facilityOfficeName.localeCompare(a?.facilityOfficeName);
            } else {
              return a?.facilityOfficeName.localeCompare(b?.facilityOfficeName);
            }
          } else if (sortFilters?.sortBy === "nickname") {
            if (sortFilters?.direction === "zToA") {
              return (b?.jobAddressNickname || "").localeCompare(
                a?.jobAddressNickname || "",
              );
            } else {
              return (a?.jobAddressNickname || "").localeCompare(
                b?.jobAddressNickname || "",
              );
            }
          } else if (sortFilters?.sortBy === "location") {
            if (sortFilters?.direction === "zToA") {
              return b?.jobAddress1.localeCompare(a?.jobAddress1);
            } else {
              return a?.jobAddress1.localeCompare(b?.jobAddress1);
            }
          } else if (sortFilters?.sortBy === "status") {
            if (sortFilters?.direction === "zToA") {
              return b?.shiftStatus.localeCompare(a?.shiftStatus);
            } else {
              return a?.shiftStatus.localeCompare(b?.shiftStatus);
            }
          } else if (sortFilters?.sortBy === "jobDate") {
            if (sortFilters?.direction === "zToA") {
              return b?.shiftSlots[0]?.startDate - a?.shiftSlots[0]?.startDate;
            } else {
              return a?.shiftSlots[0]?.startDate - b?.shiftSlots[0]?.startDate;
            }
          } else if (sortFilters?.sortBy === "totalTime") {
            if (sortFilters?.direction === "zToA") {
              return Number(b?.totalWorkedHours) - Number(a?.totalWorkedHours);
            } else {
              return Number(a?.totalWorkedHours) - Number(b?.totalWorkedHours);
            }
          }
        });
      });
    } else {
      setData((data) => {
        return data?.sort(
          (a, b) => b?.shiftSlots[0]?.startDate - a?.shiftSlots[0]?.startDate,
        );
      });
    }
  };

  const toggleReceiptModal = (row) => {
    setReceiptModal(!receiptModal);
    if (!row || isEmpty(row)) {
      setSelectedRow({});
    } else if (row || !isEmpty(row)) {
      setSelectedRow({ ...row });
    }
  };

  const toggleModal = (row) => {
    if (modal) {
      setModal(false);
    } else {
      setModal({
        jobApplicationId: row?.jobId,
        clinicianId: row?.clinicianId,
      });
    }
  };

  const css = new Map();
  css.set("upcoming", "primary");
  css.set("current", "primary");
  css.set("completed", "secondary");

  const getData = (withLoader = true) => {
  const clinicianId = values?.id || user?.clinicianId?.id;

  const isClinicianDetailsPage =
  typeof window !== "undefined" &&
  window.location.pathname.toLowerCase().includes("/admin/cliniciandetails/");

  if (isClinicianDetailsPage && !clinicianId) {
    return;
  }
    withLoader && setLoader(true);
    const isAllSelected = filters.shiftStatus.some(
      (val) => val.label === "All",
    );
    const payloadFilters = {
      ...filters,
      clinicianId: values?.id || user?.clinicianId?.id,
      shiftStatus: filters.shiftStatus.map((s) => s.value).join(","),
    };
    if (isAllSelected) delete payloadFilters.shiftStatus;

    api(GET_CLINICIAN_JOB_LIST, {}, null, payloadFilters).then((res) => {
      if (res.status === RESPONSE_OK) {
        setData(res?.data?.data);
        setCount(res.data.count);
      }
      withLoader && setLoader(false);
    });
  };

  const handleApplicationRemove = () => {
    if (Object.keys(deleteApplication).length > 0) {
      api(
        CLINICIAN_REMOVE_APPLICATION,
        {
          jobApplicationId: deleteApplication?.jobApplicationId,
          clinicianId: deleteApplication?.clinicianId,
        },
        null,
        {},
      )
        .then((res) => {
          getData();
          toggleModal();
        })
        .catch((err) => {
          toggleModal();
        });
    }
  };

  const handleShiftslots = (row) => {
    setSelectedRow(row);
    setEnterSheetModal(!enterSheetModal);
  };
  const deleteSheetToggle = (timesheetId) => {
    setDeleteSheetModal(!deleteSheetModal);
    setTimeSheetId(timesheetId);
  };

  const columns = [
    {
      name: "Shift ID",
      width: "70px",
      sortable: true,
      selector: (row) => row?.jobId?.serialNumber,
    },
    {
      name: "Facility",
      width: "120px",
      sortable: true,
      selector: (row) => row?.facilityId?.officeName,
      cell: (row) => (
        <>
          <Link
            to={
              isAdminContext
                ? `/admin/facilitydetails/${row.facilityId?.id}`
                : `/clinician/jobprofile/${row?.jobId?.id}`
            }
            target="_blank"
            id={"fullname" + row.id}>
            {row?.facilityId?.officeName}
          </Link>
          <UncontrolledTooltip
            placement="bottom"
            target={"fullname" + row.id}
            id="facility-name">
            {row?.facilityId?.officeName}
          </UncontrolledTooltip>
        </>
      ),
    },
    {
      name: "Nickname",
      width: "95px",
      sortable: true,
      selector: (row) => row?.jobId?.jobAddressNickname || "-",
    },
    {
      name: "Location",
      width: "155px",
      sortable: true,
      selector: (row) =>
        [
          row?.jobId?.jobAddress1,
          row?.jobId?.jobAddress2,
          row?.jobId?.city,
          row?.jobId?.state,
          row?.jobId?.zipCode,
        ].join(""),
      cell: (row) => (
        <AddressLabel
          arr={[
            {
              jobAddress1: row?.jobId?.jobAddress1,
              jobAddress2: row?.jobId?.jobAddress2,
              city: row?.jobId?.city,
              state: row?.jobId?.state,
              zipCode: row?.jobId?.zipCode,
            },
          ]}
        />
      ),
    },
    // {
    //   name: "Original/Updated shift",
    //   width: "160px",
    //   sortable: true,
    //   selector: (row) => row.shiftSlots,
    //   cell: (row) => {
    //     const timeZone = row?.jobId?.timeZone ?? DEFAULT_TIMEZONE;
    //     const slots = row?.shiftSlots ? row?.shiftSlots : row.jobSlots;
    //     if (!Array.isArray(slots) || slots.length === 0) {
    //       return "-";
    //     }
    //     return <DatesLabel arr={slots} timeZone={timeZone} />;
    //   }
    // },
    // {
    //   name: "Proposed Shift",
    //   width: "150px",
    //   sortable: true,
    //   selector: (row) => row?.shiftSlots[0]?.startDate,
    //   cell: (row) => (
    //     <>
    //       {row.isProposedNewTime === true ?
    //         <DatesLabel arr={row.shiftSlots} timeZone={row.timeZone ?? DEFAULT_TIMEZONE} /> : "-"
    //       }
    //     </>
    //   ),
    // },
    {
      name: "Original/Updated shift",
      width: "140px",
      sortable: true,
      selector: (row) => row.jobId?.startDate,
      cell: (row) => {
        const timeZone = row?.jobId?.timeZone ?? DEFAULT_TIMEZONE;
        const startDate = row?.jobId?.startDate;
        const endDate = row?.jobId?.endDate;
        if (!startDate || !endDate) return "-";
        const fakeShiftArray = [
      {
        id: row?.jobId?.id,
        startDate,
        endDate,
        sortOrder: 1,
      },
    ];
        return <DatesLabel arr={fakeShiftArray} timeZone={timeZone} />;
      }
    },
    {
      name: "Proposed Shift",
      width: "120px",
      sortable: true,
      selector: (row) => row?.shiftSlots[0]?.startDate,
      cell: (row) => (
        <>
          {row.isProposedNewTime ?
            <DatesLabel arr={row.shiftSlots} timeZone={row.jobId?.timeZone ?? DEFAULT_TIMEZONE} /> : "-"
          }
        </>
      ),
    },
    {
      name: "Job Type",
      width: "90px",
      sortable: true,
      selector: (row) => row?.jobId?.jobType,
      cell: (row) => (
        <span className="text-capitalize">
          {row?.jobId?.jobType === "PART_TIME" ? "PRN Shift" : row?.jobId?.jobType === "FULL_TIME" ? "Full Time" : "-"}
        </span>
      ),
    },
    {
      name: "Shift Status",
      width: "90px",
      sortable: true,
      selector: (row) => row.shiftStatus,
      cell: (row) => <div className={`text-${css.get(row.shiftStatus)} text-capitalize`}> {row.shiftStatus || "-"} </div>
    },
    ...(isAdminContext
      ? []
      : [
        {
          name: "Chat",
          width: "70px",
          selector: (row) => {
            return (<div> <Link   to={`/chat-profile?open=${row?.facilityId?.userId}`} target="_blank" state={{ receiverId: row?.facilityId?.userId}}> <TableMsgIcon /> </Link> </div>)
          }
        },
      ]),
    ...(!isSubadmin && !isReadOnlyAdmin
      ? [{
        name: "Time card",
        width: "73px",
        selector: (row) => (
          <>
            {row?.shiftStatus === "completed" &&  row?.jobId?.jobType === "PART_TIME"  ||
              row?.shiftStatus === "current" &&  row?.jobId?.jobType === "PART_TIME"  ? (
              <Fragment key={row.id}>
                {/* "#ea5455" */}
                {/* timeCardUrlForClinician */}
                <a
                  id={`a${row.id}`}
                  className="table-dot"
                  role="button"
                  tabIndex={0}
                  onClick={toggleDropdown}
                  onTouchStart={toggleDropdown}>
                  <Options
                    fill={
                      (row?.isTimesheetSubmitted && row?.timesheet?.status === "accepted") || row?.timeCardUrlForClinician || (row?.isTimesheetSubmitted && row?.timesheet?.status === "paid")
                        ? null // green
                        : row?.timesheet?.status === "pending" && row.isTimesheetSubmitted
                          ? "#ffa500" // yellow
                          : "#ea5455" // red
                    }
                  />
                </a>
                <UncontrolledPopover
                  id="table-option"
                  placement={isAdmin ? "right" : "bottom"}
                  target={`a${row.id}`}
                  trigger="focus">
                  {row?.timeCardUrlForClinician ? (
                    <Link to={row?.timeCardUrlForClinician} target="_blank" rel="noreferrer"> View </Link>
                  ) : (
                    <>
                      {!row?.timesheet ? (
                        <Link onClick={() => handleShiftslots(row)}>Create</Link>
                      ) : (
                        <>
                          {!row.isTimesheetSubmitted ? (
                            <>
                              <Link onClick={() => handleShiftslots(row)}> Edit  </Link>
                              <Link onClick={() => deleteSheetToggle(row?.timesheet?.id)}> Delete </Link>
                            </>
                          ) : (
                            <>
                              <Link onClick={() => handleShiftslots(row)}> View  </Link>
                              <Link onClick={() => deleteSheetToggle(row?.timesheet?.id)}> Delete </Link>
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </UncontrolledPopover>
              </Fragment>
            ) : (
              "-"
            )}
          </>
        ),
      }] : []),
    {
      name: "Time Worked (hrs)",
      sortable: true,
      width: "90px",
      selector: (row) => Number(row.totalWorkedHours) || 0,
      cell: (row) =>
        row.shiftStatus === "completed" &&  row?.jobId?.jobType === "PART_TIME"  || row.shiftStatus === "upcoming" &&  row?.jobId?.jobType === "PART_TIME" 
          ? Number(row.totalWorkedHours) || 0
          : "-",
    },
    {
      name: "",
      width: "110px",
      selector: (row) => (
        <div
          className="text-primary"
          style={{ display: "flex  align-items-center", width: "110px" }}>
          <Link
            style={{ marginRight: "5px" }}
            to={
              isAdminContext
                ? `/admin/jobdetail/${row.jobId.id}`
                : `/clinician/jobprofile/${row.jobId.id}`
            }
            target="_blank">
            Shift details
          </Link>
          {row.shiftStatus === "applied" && !isReadOnlyAdmin && (
            <button
              id={"rej" + row.jobId}
              className="pt-btn-icon-small btn-danger-small"
              // style={{ width: "10px !important", height: "10px", lineHeight: "10px" }}
              onClick={() => {
                toggleModal();
                setDeleteApplication({
                  jobApplicationId: row.id,
                  clinicianId: row.clinicianId.id,
                });
              }}>
              <CrossIcon />
            </button>
          )}
        </div>
      ),
    },
  ];

  // Handle multitple shift status selection logic
  const handleShiftStatusFilters = (e, item, methods) => {
    const { isSelected, removeItem, addItem, selectAll, clearAll } = methods;
    e.stopPropagation();
    if (isSelected(item)) {
      removeItem(e, item);
    } else {
      addItem(item);
    }

    //If all is seleted, selete all, else
    if (item.label === "All") {
      // Handle select/unselect all logic for "All"
      if (!isSelected(item)) {
        selectAll();
      } else {
        clearAll();
      }
    } else if (
      filters.shiftStatus.length === shiftStatus.length - 2 &&
      !isSelected(item) &&
      !filters.shiftStatus.some((shift) => shift.label === "All")
    ) {
      // If everything is selected, check "all" also
      selectAll();
    } else if (
      filters.shiftStatus.length === shiftStatus.length &&
      item.label !== "All"
    ) {
      // If one of the item is unchecked, mark "all" also as unchecked
      setFilters((prev) => ({
        ...filters,
        skip: 0,
        limit: APP_LIMIT,
        shiftStatus: prev.shiftStatus.filter(
          (ss) => ss.label !== "All" && ss.label !== item.label,
        ),
      }));
    }
  };

  const handleDeleteSheet = () => {
    api(DELETE_TIMESHEET, {}, timeSheetId, null).then((res) => {
      if (res.status === RESPONSE_OK) {
        deleteSheetToggle();
        getData(false);
      } else {
        deleteSheetToggle();
      }
    });
  }


  return (
    <>
      <div className="facility-payment-detail confirm-shift-table confirm-clinician">
        <div
          className="header"
          style={{ display: "flex" }}>
          <div
            className="user-sorting usertype"
            style={{ display: "flex" }}>
            <label htmlFor="type">Shift status</label>
            <div className="sort">
              <Select
                placeholder={"Select"}
                values={filters.shiftStatus}
                onChange={(val) => {
                  setFilters({
                    ...filters,
                    skip: 0,
                    limit: APP_LIMIT,
                    shiftStatus: val,
                  });
                }}
                options={shiftStatus}
                id="type"
                multi
                searchable={false}
                backspaceDelete={true}
                itemRenderer={({ item, methods }) => (
                  <div
                    className={`d-flex align-items-center p-1 cursor-pointer`}
                    onClick={(e) => {
                      handleShiftStatusFilters(e, item, methods);
                    }}>
                    <Input
                      className="mr-2"
                      type="checkbox"
                      checked={methods.isSelected(item)}
                      onChange={(e) => {
                        e.stopPropagation();
                      }}
                    />
                    <span className="ms-2 text-primary">{item.label}</span>
                  </div>
                )}
              />
            </div>
          </div>
        </div>
        <Modal
          centered
          isOpen={modal}
          toggle={toggleModal}
          // {...args}
          className="applicant-modal">
          <ModalHeader toggle={toggleModal}>
            Remove shift application
          </ModalHeader>
          <ModalBody>
            <label className="font-12 mb-24 d-block text-center">
              Are you sure you want to remove this shift application?
            </label>
            <div className="modal-footer">
              <button
                className="pt-btn btn-gray pt-btn-small"
                onClick={() => toggleModal()}>
                Cancel
              </button>
              <button
                className="pt-btn btn-primary pt-btn-small"
                onClick={() => handleApplicationRemove()}>
                Remove
              </button>
            </div>
          </ModalBody>
        </Modal>
        <DataTable
          columns={columns}
          data={data}
          progressPending={loader}
          progressComponent={<Loader />}
          sortIcon={<SortIcon />}
          // className="small-loader-wrap"
          noDataComponent={
            <p className="text-center no-records">No data found</p>
          }
        />

        <Suspense fallback={<Loader className="small-loader-wrap" />}>
          <CustomPagination count={count} filters={filters} setFilters={setFilters} />
        </Suspense>
      </div>
      {/* <UploadTimeCardModal
        modal={uploadModal}
        toggle={uploadToggle}
        handleSave={(file) => handleUpdate(file)}
        serverTimeCard={selectedRow?.timeCardUrlForClinician}
      /> */}

      <Suspense fallback={<Loader className="small-loader-wrap" />}>
        <EnterTimeSheetModal
          modal={enterSheetModal}
          toggle={() => {
            handleShiftslots({});
            setSelected({});
          }}
          getData={getData}
          selectedRow={selectedRow}
          canRateFacility={!isAdminContext}
        />
      </Suspense>
      {/* <DeleteTimeSheetModal
        modal={deleteSheetModal}
        toggle={() => deleteSheetToggle({})}
        data={timeSheetId}
        getData={getData}
      /> */}

      <Suspense fallback={<Loader className="small-loader-wrap" />}>
        <DeleteAJobModal
          header="Delete Time Sheet"
          message="delete this Time Sheet"
          modal={deleteSheetModal}
          toggle={deleteSheetToggle}
          deleteCallback={handleDeleteSheet}
        />
      </Suspense>

      <Suspense fallback={<Loader className="small-loader-wrap" />}>
        <ReceiptClinicianModal data={selectedRow} isOpen={receiptModal} toggle={() => toggleReceiptModal({})} loading={loader} setLoading={setLoader} totalAmount={selectedRow?.totalAmount} />
      </Suspense>
    </>
  );
}

export default MyConfirmShifts;
